import React from 'react';
import { ArrowDownRight, MessageCircle, Instagram } from 'lucide-react';
import { profile } from '../mock';

const Hero = () => {
  return (
    <section id="top" className="relative pt-28 pb-20 lg:pt-36 lg:pb-28 overflow-hidden">
      {/* warm soft backdrop blob - dusty rose */}
      <div
        aria-hidden
        className="absolute -top-24 -right-24 w-[520px] h-[520px] rounded-full opacity-70 blur-3xl"
        style={{
          background:
            'radial-gradient(circle at 30% 30%, #EBC8C0 0%, #F4EDE2 60%, transparent 75%)',
        }}
      />
      <div
        aria-hidden
        className="absolute top-1/3 -left-32 w-[400px] h-[400px] rounded-full opacity-50 blur-3xl"
        style={{
          background:
            'radial-gradient(circle at 50% 50%, #C5D2BB 0%, #F4EDE2 60%, transparent 80%)',
        }}
      />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Left content */}
        <div className="lg:col-span-7 fade-up">
          <div className="flex items-center gap-3 mb-7">
            <span className="divider-mark" />
            <span className="eyebrow">Acompañamiento humano · Uruguay</span>
          </div>

          <h1 className="font-serif text-[44px] sm:text-[56px] lg:text-[78px] leading-[0.98] text-[#2E2A23] tracking-[-0.02em]">
            Un espacio para
            <span className="italic font-light text-[#B8806E]"> habitarte </span>
            con calma,
            <br className="hidden sm:block" />
            sin juicios.
          </h1>

          <p className="mt-7 max-w-[560px] text-[17px] leading-[1.7] text-[#2E2A23]/80 font-light">
            Soy {profile.name.split(' ')[0]}. Acompaño a mujeres y familias en
            procesos de salud mental, maternidad, crianza y lactancia, desde la
            escucha y el respeto. Hace más de 10 años, una sesión a la vez.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a href={profile.whatsapp} target="_blank" rel="noreferrer" className="btn-primary">
              <MessageCircle size={16} strokeWidth={1.6} />
              Escribime y hablamos
            </a>
            <a href="#servicios" className="btn-ghost">
              Conocer servicios
              <ArrowDownRight size={16} strokeWidth={1.6} />
            </a>
          </div>

          <div className="mt-12 flex items-center gap-8 text-[#8A7E6E]">
            <a
              href={profile.instagram}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-[13px] hover:text-[#B8806E] transition-colors"
            >
              <Instagram size={16} strokeWidth={1.6} />
              @karinanegrinpsico
            </a>
            <span className="hidden sm:flex items-center gap-3 text-[13px]">
              <span className="w-1 h-1 rounded-full bg-[#B8806E]" />
              Presencial · Online
            </span>
          </div>
        </div>

        {/* Right image collage */}
        <div className="lg:col-span-5 relative h-[480px] sm:h-[560px] lg:h-[640px]">
          <div className="absolute top-0 right-0 w-[78%] h-[82%] rounded-[200px_200px_24px_24px] overflow-hidden shadow-[0_30px_80px_-30px_rgba(74,46,32,0.45)]">
            <img
              src={profile.portrait}
              alt="Karina Negrín, psicóloga"
              className="w-full h-full object-cover hero-img img-hover photo-no-watermark"
            />
          </div>

          <div className="absolute bottom-0 left-0 w-[55%] h-[42%] rounded-[24px] overflow-hidden border-[6px] border-[#F4EDE2] shadow-[0_20px_50px_-20px_rgba(74,46,32,0.35)]">
            <img
              src={profile.secondary}
              alt="Detalle"
              className="w-full h-full object-cover img-hover photo-no-watermark"
            />
          </div>

          {/* sage decorative leaf accent */}
          <div className="absolute -bottom-3 right-6 lg:right-12 w-14 h-14 rounded-full bg-[#FAF4E8] border border-[#DBCEB4] grid place-items-center shadow-md">
            <span className="w-2.5 h-2.5 rounded-full bg-[#8FA08A]" />
          </div>
        </div>
      </div>

      {/* Marquee values */}
      <div className="mt-20 lg:mt-28 border-y border-[#DBCEB4] py-5 overflow-hidden bg-[#F2E9D9]/50">
        <div className="flex marquee-track whitespace-nowrap text-[#2E2A23]/80 font-serif text-[22px] sm:text-[26px] italic">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={k} className="flex items-center gap-12 pr-12">
              <span>Escucha sin juicios</span>
              <span className="text-[#B8806E]">—</span>
              <span>Perspectiva de género</span>
              <span className="text-[#B8806E]">—</span>
              <span>Crianza respetuosa</span>
              <span className="text-[#B8806E]">—</span>
              <span>Apego seguro</span>
              <span className="text-[#B8806E]">—</span>
              <span>Salud mental perinatal</span>
              <span className="text-[#B8806E]">—</span>
              <span>Lactancia disfrutable</span>
              <span className="text-[#B8806E]">—</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
